import React, { useEffect } from "react";
import { useWriteoffModel } from "./writeoffModel";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Button, message, Steps } from "antd";
import { YhBox } from "@/components/YhBox";
import { WriteoffDataTable } from "./DataTable";
import { WriteoffDrawer } from "./writeoffDrawer";

export const WriteoffDataBox = () => {
    const {
        state,
        dataSource,
        writeoffAmount,
        selectedRowKeys,
        setOpenDrawerVisible,
        loadData,
        setSelectedData,
        selectedData,
    } = useWriteoffModel();

    useEffect(() => {
        loadData({ pageNum: 1 }).then()
    }, [state])

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedData(selectedData)
    }, [selectedRowKeys]);

    const desc: IDescription[] = [
        {
            label: "核销总额",
            value: writeoffAmount?.toFixed(2) ?? '0.00',
            color: DescriptionColorEnum.green
        },

    ]
    const onApproval = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            if (selectedData?.status === 3 || selectedData?.status === 5 || selectedData?.status === 7) {
                setOpenDrawerVisible(true);
            } else {
                message.error("此记录不可处理!");
            }
        } else {
            message.error("请选择待处理记录!");
        }
    }


    const title = (current: number) => <>
        <span>审核进度： </span>

        <Steps current={current} style={{ margin: "10px 0 " }}>
            <Steps.Step title="待申请" status={current === 0 ? "process" : current > 0 ? "finish" : "wait"} />
            <Steps.Step title="待对方确认" status={current === 1 ? "process" : current > 1 ? "finish" : "wait"} />

            {
                current === 2 ? <Steps.Step title="对方不认可" status="error" /> : <Steps.Step title="待财务确认" status={current === 3 ? "process" : current > 3 ? "finish" : "wait"} />
            }
            {
                current === 4 ? <Steps.Step title="对方已驳回" status="error" /> : <Steps.Step title="待财务审核" status={current === 5 ? "process" : current > 5 ? "finish" : "wait"} />
            }
            {
                current === 6 ? <Steps.Step title="财务已驳回" status="error" /> : <Steps.Step title="待最终审核" status={current === 7 ? "process" : current > 7 ? "finish" : "wait"} />
            }
            {
                current === 9 ? <Steps.Step title="最终已驳回" status="error" /> : <Steps.Step title="最终审核通过" status={current === 8 ? "process" : current > 8 ? "finish" : "wait"} />
            }

        </Steps>
        <div>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                disabled={selectedData?.status !== 3}
                onClick={onApproval}
            >
                财务确认
            </Button>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                disabled={selectedData?.status !== 5}
                onClick={onApproval}
            >
                财务审核
            </Button>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                disabled={selectedData?.status !== 7}
                onClick={onApproval}
            >
                最终审核
            </Button>
        </div>
    </>

    return (
        <>
            <YhBox title={title(selectedData?.status ?? 0)}>
                <WriteoffDataTable />
            </YhBox>
            <WriteoffDrawer />
        </>
    )
}